import JobListRowContainer from './job_list_row_container';

const JobListRow = JobListRowContainer;
export default JobListRow;
